export default {
	getStartDt_: ({ searchParams }) => searchParams.stdDt
};
